import {OrderStatus} from "../../components";
import {StringBuilder} from "../../AppUtils.js";
import common from "@well-b/well-b-shared";
import {Images} from "../../images/Images";

export const statusToHebrewAction = {
    [OrderStatus.accepted]: "לאשר",
    [OrderStatus.cancelled]: "לבטל",
    [OrderStatus.pending]: "לחדש"
};

export const PRICE_THRESHOLD = 100000;

export const ORDERS_PER_PAGE = 100;

export const PRICE_WARNING_PERCENT = 0.8;

export const ORDER_DEADLINE_HOURS = 72;

export const EDIT_ORDER_ERRORS = {
    CONTACT_CSM: "לא ניתן לערוך את ההזמנה - צרו קשר עם מנהלת הלקוח שלכם",
    MANAGER_APPROVE: "לא ניתן לערוך הזמנה שממתינה לאישור מנהל, מוזמנים ליצור קשר עם המנהל לסירוב/ אישור ההזמנה",
    VOUCHER: "לא ניתן לערוך שובר. ניתן לכתוב לנו בוואטסאפ ונמצא פתרון",
    CANCEL_OR_DECLINE: "לא ניתן לערוך הזמנה זו. מזמינים אותך לבצע הזמנה חדשה",
    CREDIT_CARD: "לא ניתן לערוך הזמנה שבוצעה בכרטיס אשארי. ניתן לכתוב לנו בוואטסאפ ונמצא פתרון",
    ORDER_CHANGE_TIME_EXPIRED: new StringBuilder("לא ניתן לערוך הזמנה בטווח של")
        .append(ORDER_DEADLINE_HOURS)
        .append("שעות לפני האספקה, ניתן לכתוב לנו בוואטסאפ")
        .toString()
};

export const SystemIdToOrderProposalIdPrefix = {
    [common.themeNames.wellB]: "W",
    [common.themeNames.tenBis]: "T",
    [common.themeNames.cibus]: "C"
};

export const SystemIdToIcon = {
    [common.themeNames.wellB]: Images.services.icons.ordersTable.wellbIcon,
    [common.themeNames.tenBis]: Images.services.icons.ordersTable.tenbisIcon,
    [common.themeNames.cibus]: Images.services.icons.ordersTable.cibusIcon
};

export const OrderTableColumns = {
    providerDiscount: "providerDiscount",
    deliveryProviderDiscount: "deliveryProviderDiscount",
    tip: "tip",
    discount: "discount",
    assignedPartners: "assignedPartners",
    actions: "actions"
};
